// extracted by mini-css-extract-plugin
export default {"inputBloc":"InputSwitch_inputBloc__Rn+se","label":"InputSwitch_label__98loD"};